import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {ObjectIdentifierData} from "../../../../../core/shared/basic/object-identifier-data";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";

@Component({
    selector: 'ea-value-list-widget',
    templateUrl: './ea-value-list-widget.component.html',
    standalone: false
})
export class EaValueListWidgetComponent implements OnInit, OnChanges, OnDestroy {

    @Input() columnId: number;
    @Output() onValueSelect: EventEmitter<ObjectIdentifierData> = new EventEmitter<ObjectIdentifierData>();

    busy: boolean;
    initialized: boolean;
    valueWidgetData: WidgetData;

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent() {
        this.refreshComponent();
    }

    refreshComponent() {
        if (this.columnId) {
            const filter = FilterCriteria.create('e.columnId', FilterCriteria.cOperatorEqual, this.columnId);
            this.valueWidgetData = WidgetFactory.createWidgetTableEntityQl(
                'ea.value.list.widget',
                'Column Values',
                'ea.EaColumnValue',
                'No values found',
                [filter],
                [],
                true
            );
        }
        this.initialized = true;
    }

    handleValueSelect(event: ObjectIdentifier | ObjectIdentifierData) {
        this.onValueSelect.emit({objectType: event.objectType, objectId: event.objectId} as ObjectIdentifierData);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes["columnId"]) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
